import { render, staticRenderFns } from "./DispatchingResultsByAgent.vue?vue&type=template&id=4dc88ba5&scoped=true"
import script from "./DispatchingResultsByAgent.vue?vue&type=script&lang=js"
export * from "./DispatchingResultsByAgent.vue?vue&type=script&lang=js"
import style0 from "./DispatchingResultsByAgent.vue?vue&type=style&index=0&id=4dc88ba5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc88ba5",
  null
  
)

export default component.exports